import React from "react";

import { getAutomationDataAttr } from "@/utils/automationUtils";
import { Image, Text, TextColors, TextTypes } from "@/component-library";

import "../NoteAddendum.styles.scss";

export function AddendumLink({ onClick }) {
  return (
    <div
      className="AddendumLink"
      onClick={onClick}
      {...getAutomationDataAttr("note-addendum-link")}
    >
      <div className="AddendumLink--left">
        <Text layout="block" type={TextTypes.heading2}>
          Add Addendum
        </Text>

        <Text color={TextColors.grey} layout="block" type={TextTypes.paragraph}>
          Add details to an existing note.
        </Text>
      </div>

      <Image alt="arrow" className="AddendumLink__icon" src="icons/common/chevron-right-blue.svg" />
    </div>
  );
}
